export const GET_VENDORAWARDED = 'GET_VENDORAWARDED';
export const SET_VENDORAWARDED = 'SET_VENDORAWARDED';
export const REFRESH_VENDORAWARDED = 'REFRESH_VENDORAWARDED';
